import { render } from "./BriefView.vue?vue&type=template&id=239b507d&scoped=true"
import script from "./BriefView.vue?vue&type=script&lang=js"
export * from "./BriefView.vue?vue&type=script&lang=js"

import "./BriefView.vue?vue&type=style&index=0&id=239b507d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239b507d"]])

export default __exports__